import type { Editor } from '@tiptap/react';

export function hasCommentsKit(editor: Editor | null): boolean {
  if (!editor) return false;

  return editor.extensionManager.extensions.some((ext) => ext.name === 'comments');
}
